module.exports = __webpack_public_path__ + "img/fragment_1000.3001d2f7.png";